import { render, staticRenderFns } from "./remove-component-modal.vue?vue&type=template&id=1e12fd42"
import script from "./remove-component-modal.vue?vue&type=script&lang=ts"
export * from "./remove-component-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports